import React from "react";
import styles from "./DescOne.module.scss";

function DescOne({ value }) {
  return <div className={styles.descOne}>{value}</div>;
}

export default DescOne;
